import type { PropsWithChildren } from 'react';

import { Flex } from '@/components/Flex';
import { useListingState } from '@/hooks/useListingState';

import { useListingFiltersProvider } from '../../ListingFiltersProviderContext';
import { FiltersCounter, FiltersCounterForSearchView } from '../FiltersCounter';

import * as S from '../FiltersModal/FiltersModal.styles';

interface FilterAccordionProps {
  attribute?: string;
  render?: (isVisible: boolean) => JSX.Element;
  summary: string;
}

export const FilterAccordion = ({
  attribute,
  children,
  render,
  summary,
}: PropsWithChildren<FilterAccordionProps>) => {
  const { modalState } = useListingState();
  const isOpen = modalState.openedTab === attribute;
  const { listingFiltersType } = useListingFiltersProvider();
  return (
    <S.Details data-test-id='FiltersModalFilterAccordion' open={isOpen}>
      <S.Summary data-test-id='FiltersModalSummary'>
        <Flex gridGap={1}>
          {summary.toUpperCase()}{' '}
          {attribute &&
            (listingFiltersType === 'PLP' ? (
              <FiltersCounter
                attribute={attribute}
                data-test-id={`FiltersModal${attribute}Counter`}
              />
            ) : (
              <FiltersCounterForSearchView
                attribute={attribute}
                data-test-id={`FiltersModal${attribute}Counter`}
              />
            ))}
        </Flex>

        <S.ChevronIcon name='chevronDown' />
      </S.Summary>

      <S.DetailsBody data-test-id='FiltersModalDetailsBody'>
        {children} {render?.(isOpen)}
      </S.DetailsBody>
    </S.Details>
  );
};
